import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '../views/Home.vue';
import Detail from '../views/Detail.vue';
import About from '../components/about.vue';
import Contact from '../components/contact.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
  },
  {
    path: '/detail',
    component: Detail,
    name: 'detail',
    children: [
      { path: '/detail', component: Detail, name: 'detail', hidden: true },
      { path: '/detail/about', component: About, name: 'about' },
      // { path: '/terms', component: Terms, name: 'terms' },
      // { path: '/policy', component: Policy, name: 'policy' },
      { path: '/detail/contact', component: Contact, name: 'contact' }
    ],
  },
];

const router = new VueRouter({
  routes,
});

export default router;
